import React, { useEffect } from 'react'
import CreateAccount from '../createAccount/CreateAccount'
export default function LandingPage() {
  useEffect(() => {
    localStorage.clear();
  }, []);
 
  return (
    <div>
        
        <CreateAccount/>
        
    </div>
  )
}
